import { FormMonitor } from '../protocols/monitor';

export const formMonitorBlank: FormMonitor = {
  flg_api_integracao_ativo: false,
};

export const LIMIT_REGISTER_PER_PAGE = 8;
